import React, { useEffect, useState } from "react";
import pauserecord from "../images/poserecord.svg";
import stoprecord from "../images/stoprecord.svg";
import mic from "../images/mic.svg";
// import Timer from "../../../helper/Timer";
import { clearConsole } from "../../../helper/CommonFuncs";
import "../AllNotes.css";
import { stopRecordingMain } from "../../../redux/actions/note.action";
import { ShowAlert } from "../../../common/alert";
import InfoComponent from "../../Vim-integration/container/Demo/NotesMobileView/InfoComponent";
import { sendDataDogLogs } from "../../notes/actions/notesAct";
import Timewatch from "../../notes/component/TimeWatch";
let rec;
let stream = null;
let audioFile = null;
// let audioPlayer = new Audio();
// let counter = new Timer();
let timerLabel;
let data = [];
let streams = [];
let startBtn;
let stopBtn;
let pauseBtn;
let animFrame;
export const Audio = (props) => (
   <audio
      controls
      className="shadow round-border-l"
      onError={() => {
         clearConsole();
      }}
      controlsList="nodownload"
      {...props}
   />
);
async function createNode(h) {
   if (document.getElementsByClassName("visualizer-div-demo").length > 0) {
      const visualizerDiv = document.getElementsByClassName("visualizer-div-demo")[0];

      // Ensure only 15 nodes are created
      const existingNodes = visualizerDiv.getElementsByClassName("visualizer-node");
      if (existingNodes?.length >= 100) {
         // Remove excess nodes
         while (existingNodes?.length > 50) {
            existingNodes[0].remove();
         }
      }

      let node = document.createElement("div");
      node.style.width = "8px";
      node.style.height = `${h}px`;
      node.className = " visualizer-node bg-primary rounded-top rounded-bottom m-3 float-left flex-shrink-0 ";

      let visualizer = document.getElementsByClassName("visualizer-div-demo")[0] || false;
      if (visualizer) {
         visualizer && visualizer.appendChild(node);
         visualizer.scrollLeft += 100;
      }
   }
}
async function visualise() {
   if (!stream) return;
   var audioContext = new (window.AudioContext || window.webkitAudioContext)();
   var analyser = audioContext.createAnalyser();
   var dataArray = new Uint8Array(analyser.frequencyBinCount);

   if (stream instanceof Blob) {
      const arrayBuffer = await new Response(stream).arrayBuffer();
      const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
      source = audioContext.createBufferSource();
      source.buffer = audioBuffer;
      source.connect(analyser);
      source.start(0);
   } else {
      var source = audioContext.createMediaStreamSource(stream);
      source.connect(analyser);
   }
   analyser.fftSize = 64;
   var bufferLength = analyser.fftSize;
   var dataArray = new Uint8Array(bufferLength);
   var viz = () => {
      analyser.getByteFrequencyData(dataArray);
      let val = dataArray.reduce((prev, curr) => prev + curr) / 64;
      createNode(val);
      createNode(dataArray[12]);
      createNode(dataArray[21]);
      createNode(dataArray[42]);
      animFrame = requestAnimationFrame(viz);
   };
   viz();
}
function startRecorder(onstop, startStopWatch = () => { }, uploadMediaV2 = () => { }, onPermissionNotAllowed = () => { }) {
   navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then((mediaStream) => {
         stream = mediaStream;
         streams.push(mediaStream);
         visualise();
         const recorder = new MediaRecorder(mediaStream);
         rec = recorder;
         let timeoutId;
         let chunks = [];

         recorder.ondataavailable = (e) => chunks.push(e.data);
         recorder.onstop = (e) => {
            uploadMediaV2(new Blob(chunks));

            clearTimeout(timeoutId);
            chunks = [];
            if (!localStorage.getItem("recordingPaused")) {
               startRecording();
               stream = mediaStream;
            }
            if (localStorage.getItem("isFinal")) {
               streams.forEach((stream) => {
                  stream.getTracks().forEach((track) => track.stop()); // Stop all tracks in each stream
               });
               // mediaStream && mediaStream.getTracks().forEach((track) => track.stop());
            }
         };

         startStopWatch();

         const startRecording = () => {
            recorder.start();
            stream = mediaStream;
            timeoutId = setTimeout(() => {
               recorder.stop();
            }, 30000);
         };

         // Start the recorder initially
         startRecording();
      })
      .catch((error) => {
         setTimeout(() => {
            onPermissionNotAllowed();
         }, 1000);
         ShowAlert("Please allow microphone permissions", "error");

         // Handle the error here, such as displaying a message to the user
         console.error("Error accessing microphone:", error);
         sendDataDogLogs("recording-error-accessing-microphone");
      });
}

const RecordingNoteCompDemo = (props) => {
   const {
      onStart,
      onStop,
      onPause,
      onResume,
      setIsRecording,
      setIsStartRecording,
      discardRecording,
      setShowComponent,
      showBanner,
      removeRecordingFromUrl,
      noteId,
      uploadMediaV2 = () => { },
      initialTime = "",
      setInitialTime,
      onPermissionNotAllowed,
      patientDetails,
      isDemo = false,
      intitalDemoDone = false,
      setInitialDemo,
   } = props;
   const [showRecorder, setShowRecorder] = useState(true);
   const [loader, setLoader] = useState(false);
   const [showStopButton, setShowStopButton] = useState(false);
   const [enableSubmitButton, setEnableSubmitButton] = useState(false);
   const [getsecond, setGetSecond] = useState({ seconds: 0, minutes: 0 });
   const [state, setstate] = useState({
      isRecording: false,
      isPaused: false,
      isBlocked: false,
   });
   const [stopWatch, setStopWatch] = useState({
      start: false,
      pause: false,
      stop: false,
      play: false,
   });
   useEffect(() => {
      localStorage.removeItem("stopWatch");
      localStorage.removeItem("intervalStart");
      startBtn = document.getElementById("btn-start-video");
      startBtn.onclick = () => { };
      stopBtn = document.getElementById("btn-stop-video");
      stopBtn.onclick = () => {
         sendDataDogLogs("recording-stopped");
         localStorage.setItem("recordingPaused", "true");
         cancelAnimationFrame(animFrame);
         localStorage.setItem("isFinal", "true");
         if (rec && rec.state === "recording") {
            // Case 1 or 3: If currently recording
            rec.stop(); // This triggers rec.onstop and uploadMediaV2
         } else {
            // Case 2: Already paused/stopped, manually upload empty blob or use stored chunks
            uploadMediaV2(new Blob([])); // Fallback blob if nothing was recorded
         }

         setstate({ ...state, isRecording: false, isPaused: false });
         setStopWatch({ start: false, pause: false, stop: true, play: false });
         removeRecordingFromUrl();
         stopRecordingMain();
         onStop && onStop("");

         streams.forEach((stream) => {
            stream.getTracks().forEach((track) => track.stop()); // Stop all tracks
         });
      };

      pauseBtn = document.getElementById("btn-pause-video");
      pauseBtn.onclick = () => {
         if (rec === undefined || rec === null) {
            sendDataDogLogs("recording-started");
            localStorage.removeItem("isFinal");
            localStorage.removeItem("recordingPaused");
            localStorage.removeItem("uploadingPending");
            startRecorder(
               onStop,
               () => {
                  setStopWatch({ start: true, pause: false, stop: false, play: false });
                  setstate({ ...state, isRecording: true, isPaused: false });
                  setShowStopButton(true);
                  setEnableSubmitButton(true);
               },
               uploadMediaV2,
               onPermissionNotAllowed
            );

            return;
         }
         if (rec.state === "recording") {
            sendDataDogLogs("recording-paused");
            localStorage.setItem("recordingPaused", "true");
            rec.stop();
            cancelAnimationFrame(animFrame);
            setstate({
               ...state,
               isPaused: true,
               isRecording: false,
            });
            setStopWatch({
               start: false,
               pause: true,
               stop: false,
               play: false,
            });
            let stop = localStorage.getItem("intervalStart");
            if (stop && stop === "true") {
               localStorage.setItem("stopWatch", "true");
               localStorage.removeItem("intervalStart");
            }
            setIsRecording(false);
         } else {
            sendDataDogLogs("recording-resumed");
            if (intitalDemoDone && rec?.state === "inactive") {
               localStorage.removeItem("isFinal");
               localStorage.removeItem("recordingPaused");
               localStorage.removeItem("uploadingPending");
               startRecorder(
                  onStop,
                  () => {
                     setStopWatch({ start: true, pause: false, stop: false, play: false });
                     setstate({ ...state, isRecording: true, isPaused: false });
                     setShowStopButton(true);
                     setEnableSubmitButton(true);
                  },
                  uploadMediaV2,
                  onPermissionNotAllowed
               );
               setInitialDemo(false);

               return;
            }
            localStorage.removeItem("recordingPaused");
            startRecorder(
               onStop,
               () => {
                  setStopWatch({ start: false, pause: false, stop: false, play: true });
               },
               uploadMediaV2
            );
            setIsRecording(true);
            startBtn.style.display = "none";
            stopBtn.style.display = "initial";
            pauseBtn.style.display = "initial";
            setstate({ ...state, isRecording: true, isPaused: false });
         }
      };
      return () => {
         cancelAnimationFrame(animFrame);
         streams.forEach((stream) => {
            stream.getTracks().forEach((track) => track.stop()); // Stop all tracks in each stream
         });
      };
   }, [intitalDemoDone]);

   useEffect(() => {
      localStorage.removeItem("isFinal");
      localStorage.removeItem("recordingPaused");
      localStorage.removeItem("uploadingPending");
      setstate({ ...state, isPaused: true, isRecording: false });
      return () => {
         cancelAnimationFrame(animFrame);
         streams.forEach((stream) => {
            stream.getTracks().forEach((track) => track.stop()); // Stop all tracks in each stream
         });
      };
   }, []);

   const handlePauseNext = () => {
      localStorage.setItem("isFinal", "true");
      localStorage.removeItem("recordingPaused");
      setLoader(true);
      streams.forEach((stream) => {
         stream.getTracks().forEach((track) => track.stop()); // Stop all tracks in each stream
      });
      setTimeout(() => {
         uploadMediaV2(new Blob([]));
         setstate({ ...state, isRecording: false, isPaused: false });
         setStopWatch({ start: false, pause: false, stop: true, play: false });
         removeRecordingFromUrl();
         stopRecordingMain();
         onStop && onStop("");
      }, 1000);
      sendDataDogLogs("recording-submit-button-clicked");
   };

   return (
      <div className="">
         <div className={` no-scrollbar d-flex flex-column justify-content-center align-items-center `}>
            <div className="recording-time-text-demo  ">
               <Timewatch
                  setInitialTime={setInitialTime}
                  initialTime={initialTime}
                  noteId={noteId}
                  stopWatch={stopWatch}
                  setGetSecond={setGetSecond}
               />
            </div>
            <div className="pb-2 pt-4">
               <InfoComponent step={2} />
            </div>
            <div
               style={{ flex: 1, height: "10vh", marginTop: "52px", marginBottom: "60px" }}
               className="d-flex align-items-center container-recording-visualizer-epic-vim-demo  "
            >
               <div
                  id="btn-start-video"
                  className={` w-100 visualizer-epic-container-main-v2 visualizer-div-demo d-flex align-items-center custom-height-v2-version-demo overflow-auto scroll-bar-audio-recorder`}
               >
                  {!state.isRecording ? <div style={{ height: "5px" }} className="bg-white" /> : null}
               </div>
            </div>

            <div style={{ marginTop: "20px" }} className="d-flex ">
               <img
                  id="btn-pause-video"
                  src={state.isPaused ? mic : pauserecord}
                  alt="poserecord"
                  className={` mr-3 cursor-pointer  ${!showRecorder ? "d-block " : "d-block"}`}
               />
               <img
                  id="btn-stop-video"
                  src={stoprecord}
                  alt="stoprecord"
                  className={`cursor-pointer  ${showStopButton ? "d-block" : "d-none"}`}
               />
            </div>
            {state.isPaused && enableSubmitButton && (
               <div
                  onClick={() => {
                     if (!loader) {
                        handlePauseNext();
                     }
                  }}
                  style={{ marginTop: "24px" }}
                  className="next-container cursor-pointer d-flex justify-items-center text-center justify-content-center"
               >
                  <div className="next-text text-center">{loader ? "Creating..." : "Submit"}</div>
               </div>
            )}
         </div>
      </div>
   );
};

export default RecordingNoteCompDemo;